import * as brandColors from '../../../../../utils/brand-colors';

export default () => ({
  statusCell: {
    padding: '.5em',
    minWidth: 200,
    maxWidth: 300,
  },
  row: {
    cursor: 'pointer',
    '&:hover': { background: brandColors.grey[50] },
  },
  isUpdatingProgress: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    margin: '1em',
  },
  eventActions: { textAlign: 'right' },
  new: { '& td': { fontWeight: 600 } },
  paperRoot: { overflow: 'auto' },
  eventIdField: { color: brandColors.grey[500] },
  eventName: { display: 'flex' },
  eventNameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  dueDateIcon: {
    marginRight: 4,
    fontSize: '18px',
    color: brandColors.danger.main,
  },
});
